import React, { useState } from "react";
import { FaAngleDoubleDown, FaAngleDown, FaAngleUp } from "react-icons/fa";
import { IoMdPerson } from "react-icons/io";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Modal from "../components/modal/Modal";
import kyclogo from "../../assets/kyc_2.jpeg";
import LogoComp from "../components/logo/LogoComp";

const Landing = () => {
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className="relative h-screen w-full px-6 md:px-10"
    >
      <img
        src={kyclogo}
        alt="logo"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-black/100 opacity-70"></div>
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center">
        <LogoComp />
        <p className="text-white text-2xl md:text-4xl lg:text-5xl font-bold font-poet italic max-w-md md:max-w-2xl lg:max-w-4xl mx-auto my-6">
          We value you and your information!
        </p>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 2 }}
        >
          <h3 className="text-white text-xl py-4 px-4 rounded-xl font-bold font-poet italic bg-gray-900/75 backdrop-blur-sm shadow-xl max-w-3xl mx-auto border border-gray-700/30">
            <span>Choose category to be onboarded on VAS2Nets Platform</span>
            <motion.span
              animate={{ y: [0, 8, 0], opacity: [1, 0.6, 1] }}
              transition={{
                repeat: Infinity,
                duration: 1.5,
                ease: "easeInOut",
              }}
              className="block mt-2 text-2xl"
            >
              ⬇️
            </motion.span>
          </h3>
        </motion.div>

        <div className="flex flex-col lg:flex-row items-center justify-center gap-6 lg:gap-10 mt-10 w-full">
          <button
            onClick={toggleModal}
            className="bg-red-800 hover:bg-red-600 text-white py-3 px-6 text-lg rounded-2xl md:text-xl capitalize flex items-center space-x-4"
          >
            <span className="tracking-wider font-bold font-poet text-xl">
              Organization
            </span>
            <span>
              {showModal ? (
                <FaAngleUp className="text-lg" />
              ) : (
                <FaAngleDown className="text-lg" />
              )}
            </span>
          </button>

          {showModal && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
              <Modal closeModal={toggleModal} />
            </div>
          )}

          <Link
            to="/kycform/individual"
            className="bg-red-600 hover:bg-red-400 text-white py-3 px-6 text-lg rounded-2xl md:text-xl capitalize flex items-center space-x-4"
          >
            <span className="tracking-wider font-bold font-poet text-xl">
              Individual
            </span>
            <span>
              <IoMdPerson className="text-lg" />
            </span>
          </Link>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 2.5 }}
          className="py-8"
        ></motion.div>
      </div>
    </motion.section>
  );
};

export default Landing;
